module.exports = __webpack_public_path__ + "static/media/20190201_153857.a0714310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/20190201_153857.jpg
// module id = 481
// module chunks = 0